import {
  transformFromWGSToGCJ,
  transformFromGCJToBaidu,
  transformFromBaiduToGCJ,
  transformFromGCJToWGS,
  transfromBaidutoWGS84,
  transfromWGS84toBaidu
} from "@/libs/tools.js";

export const cp0 = [121.462648,31.176765]
export const cp1 = [121.466672,31.184479]
export const cp2 = [121.463859,31.168445]

// let points = [
//   [121.458082,31.178693],cp0
//   [121.458069,31.178720],
//   [121.458042,31.178805],
//   [121.457921,31.179278],
//   [121.457904,31.179287],
//   [121.457577,31.179386],
//   [121.457508,31.179403],
//   [121.457355,31.179446],
//   [121.457350,31.179446],
//   [121.457999,31.181035],
//   [121.458016,31.181053],
//   [121.458343,31.180941],
//   [121.458343,31.180936],
//   [121.458399,31.181093],
//   [121.458517,31.181436],
//   [121.458589,31.181420],
//   [121.458602,31.181432],
//   [121.458600,31.181444],
//   [121.458957,31.181458],
//   [121.459018,31.181575],
//   [121.459230,31.182045],
//   [121.459353,31.182288],
//   [121.459461,31.182505],
//   [121.459574,31.182783],
//   [121.459805,31.183266],
//   [121.459827,31.183274],
//   [121.459888,31.183327],
//   [121.460327,31.184130],
//   [121.460432,31.184317],
//   [121.460815,31.185012],
//   [121.460924,31.185137],
//   [121.461098,31.185368],
//   [121.461341,31.185677],
//   [121.461412,31.185781],
//   [121.461886,31.186198],
//   [121.462068,31.186369],
//   [121.462104,31.186399],
//   [121.462104,31.186403],
//   [121.462118,31.186415],
//   [121.462117,31.186412],cp1
//   [121.462074,31.186373],
//   [121.461890,31.186203],
//   [121.461416,31.185785],
//   [121.461346,31.185681],
//   [121.461103,31.185373],
//   [121.460928,31.185142],
//   [121.460820,31.185016],
//   [121.460437,31.184321],
//   [121.460331,31.184134],
//   [121.459892,31.183331],
//   [121.459831,31.183279],
//   [121.459810,31.183270],
//   [121.459805,31.183266],
//   [121.459579,31.182787],
//   [121.459466,31.182510],
//   [121.459357,31.182288],
//   [121.459235,31.182050],
//   [121.459022,31.181580],
//   [121.458961,31.181463],
//   [121.458957,31.181458],
//   [121.458591,31.181449],
//   [121.458593,31.181414],
//   [121.458606,31.181427],
//   [121.458521,31.181440],
//   [121.458399,31.181097],
//   [121.458347,31.180941],
//   [121.458343,31.180936],
//   [121.458021,31.181053],
//   [121.458016,31.181053],
//   [121.458003,31.181040],
//   [121.457355,31.179450],
//   [121.457350,31.179446],
//   [121.457503,31.179408],
//   [121.457573,31.179390],
//   [121.457899,31.179291],
//   [121.457917,31.179283],
//   [121.458038,31.178810],
//   [121.458082,31.178693],cp0
//   [121.458042,31.178680],
//   [121.458055,31.178692],
//   [121.458112,31.178594],
//   [121.457785,31.178076],
//   [121.457763,31.178082],
//   [121.457776,31.178094],
//   [121.457790,31.178085],
//   [121.457751,31.178020],
//   [121.457769,31.176137],
//   [121.457838,31.175596],
//   [121.457878,31.175257],
//   [121.457999,31.175075],
//   [121.458029,31.175014],
//   [121.458083,31.174737],
//   [121.458122,31.174633],
//   [121.458221,31.174208],
//   [121.458343,31.173723],
//   [121.458400,31.173527],
//   [121.458435,31.173488],
//   [121.458474,31.173440],
//   [121.458505,31.173354],
//   [121.458513,31.173328],
//   [121.458688,31.172808],
//   [121.458714,31.172764],
//   [121.458818,31.172461],
//   [121.459162,31.171547],
//   [121.459279,31.171100],
//   [121.459279,31.171095],
//   [121.459283,31.171035],
//   [121.459244,31.170419],
//   [121.459297,31.170380],cp2
//   [121.459311,31.170392],
//   [121.459324,31.170404],
//   [121.459324,31.170402],
//   [121.459471,31.170393],
//   [121.459472,31.170393],
//   [121.459524,31.170643],
//   [121.459537,31.170655],
//   [121.459501,31.170641],
//   [121.459376,31.170936],
//   [121.459283,31.171095],
//   [121.459166,31.171542],
//   [121.458822,31.172457],
//   [121.458718,31.172760],
//   [121.458692,31.172803],
//   [121.458518,31.173323],
//   [121.458509,31.173349],
//   [121.458505,31.173349],
//   [121.458479,31.173436],
//   [121.458439,31.173484],
//   [121.458400,31.173523],
//   [121.458347,31.173718],
//   [121.458226,31.174203],
//   [121.458126,31.174629],
//   [121.458087,31.174733],
//   [121.458034,31.175010],
//   [121.458003,31.175070],
//   [121.457882,31.175253],
//   [121.457843,31.175591],
//   [121.457773,31.176133],
//   [121.457751,31.178015],
//   [121.457781,31.178067],
//   [121.457769,31.178078],
//   [121.457782,31.178090],
//   [121.457790,31.178085],
//   [121.458112,31.178594],
//   [121.458082,31.178693],
// ]
// let arr = []
// for(var i = 0;i<points.length;i++){
//   let params = transformFromWGSToGCJ(points[i][1],points[i][0])
//   arr.push([params.longitude,params.latitude])
// }

// console.log(JSON.stringify(arr),111)

export const line = [
  [121.462648,31.176765],
  [121.462635,31.176792],
  [121.462608,31.176877],
  [121.462487,31.177351],
  [121.46247,31.17736],
  [121.462144,31.17746],
  [121.462075,31.177477],
  [121.461923,31.17752],
  [121.461918,31.17752],
  [121.462565,31.179109],
  [121.462582,31.179127],
  [121.462908,31.179014],
  [121.462908,31.179009],
  [121.462964,31.179166],
  [121.463082,31.179509],
  [121.463154,31.179492],
  [121.463167,31.179504],
  [121.463165,31.179516],
  [121.463521,31.17953],
  [121.463582,31.179646],
  [121.463793,31.180116],
  [121.463916,31.180359],
  [121.464023,31.180576],
  [121.464136,31.180854],
  [121.464366,31.181336],
  [121.464388,31.181344],
  [121.464449,31.181397],
  [121.464887,31.1822],
  [121.464992,31.182387],
  [121.465374,31.183081],
  [121.465482,31.183206],
  [121.465656,31.183436],
  [121.465898,31.183745],
  [121.465969,31.183849],
  [121.466442,31.184265],
  [121.466623,31.184436],
  [121.466659,31.184466],
  [121.466659,31.18447],
  [121.466673,31.184482],
  [121.466672,31.184479],//cp1
  [121.466629,31.18444],
  [121.466446,31.18427],
  [121.465973,31.183853],
  [121.465903,31.183749],
  [121.465661,31.183441],
  [121.465486,31.183211],
  [121.465379,31.183085],
  [121.464997,31.182391],
  [121.464891,31.182204],
  [121.464453,31.181401],
  [121.464392,31.181349],
  [121.464371,31.18134],
  [121.464366,31.181336],
  [121.464141,31.180858],
  [121.464028,31.180581],
  [121.46392,31.180359],
  [121.463798,31.180121],
  [121.463585,31.179651],
  [121.463525,31.179535],
  [121.463521,31.17953],
  [121.463156,31.179521],
  [121.463158,31.179486],
  [121.463171,31.179499],
  [121.463086,31.179513],
  [121.462964,31.17917],
  [121.462912,31.179014],
  [121.462908,31.179009],
  [121.462587,31.179127],
  [121.462582,31.179127],
  [121.462569,31.179114],
  [121.461923,31.177524],
  [121.461918,31.17752],
  [121.462071,31.177482],
  [121.46214,31.177464],
  [121.462465,31.177364],
  [121.462483,31.177356],
  [121.462604,31.176882],
  [121.462648,31.176765],//cp0
  [121.462608,31.176752],
  [121.462621,31.176764],
  [121.462678,31.176666],
  [121.462352,31.176149],
  [121.46233,31.176155],
  [121.462343,31.176167],
  [121.462357,31.176158],
  [121.462318,31.176093],
  [121.462335,31.174209],
  [121.462404,31.173667],
  [121.462444,31.173328],
  [121.462565,31.173146],
  [121.462595,31.173084],
  [121.462649,31.172807],
  [121.462687,31.172703],
  [121.462786,31.172278],
  [121.462908,31.171792],
  [121.462965,31.171596],
  [121.462999,31.171557],
  [121.463038,31.171509],
  [121.463069,31.171423],
  [121.463077,31.171396],
  [121.463252,31.170876],
  [121.463278,31.170832],
  [121.463381,31.170528],
  [121.463724,31.169613],
  [121.463841,31.169166],
  [121.463841,31.169161],
  [121.463845,31.169101],
  [121.463806,31.168484],
  [121.463859,31.168445],//cp2
  [121.463873,31.168457],
  [121.463886,31.168469],
  [121.463886,31.168467],
  [121.464032,31.168458],
  [121.464033,31.168458],
  [121.464085,31.168708],
  [121.464098,31.16872],
  [121.464062,31.168706],
  [121.463938,31.169001],
  [121.463845,31.169161],
  [121.463728,31.169608],
  [121.463385,31.170524],
  [121.463282,31.170828],
  [121.463256,31.170871],
  [121.463082,31.171391],
  [121.463073,31.171418],
  [121.463069,31.171418],
  [121.463043,31.171505],
  [121.463003,31.171553],
  [121.462965,31.171592],
  [121.462912,31.171787],
  [121.462791,31.172273],
  [121.462691,31.172699],
  [121.462652,31.172803],
  [121.4626,31.17308],
  [121.462569,31.173141],
  [121.462448,31.173324],
  [121.462409,31.173662],
  [121.462339,31.174205],
  [121.462318,31.176088],
  [121.462348,31.17614],
  [121.462336,31.176151],
  [121.462349,31.176163],
  [121.462357,31.176158],
  [121.462678,31.176666],
  [121.462648,31.176765]]

export const linex = {
  line1: [
    {
      left_line: [
        [121.462648,31.176765],
        [121.462635,31.176792],
        [121.462608,31.176877],
        [121.462487,31.177351],
        [121.46247,31.17736],
        [121.462144,31.17746],
        [121.462075,31.177477],
        [121.461923,31.17752],
        [121.461918,31.17752],
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462648,31.176765],
      distance: 0,
    },
    {
      left_line: [
        [121.462635,31.176792],
        [121.462608,31.176877],
        [121.462487,31.177351],
        [121.46247,31.17736],
        [121.462144,31.17746],
        [121.462075,31.177477],
        [121.461923,31.17752],
        [121.461918,31.17752],
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462635,31.176792],
      distance: 26.923076923076923,
    },
    {
      left_line: [
        [121.462608,31.176877],
        [121.462487,31.177351],
        [121.46247,31.17736],
        [121.462144,31.17746],
        [121.462075,31.177477],
        [121.461923,31.17752],
        [121.461918,31.17752],
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462608,31.176877],
      distance: 53.84615384615385,
    },
    {
      left_line: [
        [121.462487,31.177351],
        [121.46247,31.17736],
        [121.462144,31.17746],
        [121.462075,31.177477],
        [121.461923,31.17752],
        [121.461918,31.17752],
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462487,31.177351],
      distance: 80.76923076923077,
    },
    {
      left_line: [
        [121.46247,31.17736],
        [121.462144,31.17746],
        [121.462075,31.177477],
        [121.461923,31.17752],
        [121.461918,31.17752],
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.46247,31.17736],
      distance: 107.6923076923077,
    },
    {
      left_line: [
        [121.462144,31.17746],
        [121.462075,31.177477],
        [121.461923,31.17752],
        [121.461918,31.17752],
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462144,31.17746],
      distance: 134.6153846153846,
    },
    {
      left_line: [
        [121.462075,31.177477],
        [121.461923,31.17752],
        [121.461918,31.17752],
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462075,31.177477],
      distance: 161.53846153846155,
    },
    {
      left_line: [
        [121.461923,31.17752],
        [121.461918,31.17752],
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.461923,31.17752],
      distance: 188.46153846153845,
    },
    {
      left_line: [
        [121.461918,31.17752],
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.461918,31.17752],
      distance: 215.3846153846154,
    },
    {
      left_line: [
        [121.462565,31.179109],
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462565,31.179109],
      distance: 242.30769230769232,
    },
    {
      left_line: [
        [121.462582,31.179127],
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462582,31.179127],
      distance: 269.2307692307692,
    },
    {
      left_line: [
        [121.462908,31.179014],
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462908,31.179014],
      distance: 296.15384615384613,
    },
    {
      left_line: [
        [121.462908,31.179009],
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462908,31.179009],
      distance: 323.0769230769231,
    },
    {
      left_line: [
        [121.462964,31.179166],
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.462964,31.179166],
      distance: 350,
    },
    {
      left_line: [
        [121.463082,31.179509],
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.463082,31.179509],
      distance: 376.9230769230769,
    },
    {
      left_line: [
        [121.463154,31.179492],
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.463154,31.179492],
      distance: 403.84615384615387,
    },
    {
      left_line: [
        [121.463167,31.179504],
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.463167,31.179504],
      distance: 430.7692307692308,
    },
    {
      left_line: [
        [121.463165,31.179516],
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.463165,31.179516],
      distance: 457.6923076923077,
    },
    {
      left_line: [
        [121.463521,31.17953],
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.463521,31.17953],
      distance: 484.61538461538464,
    },
    {
      left_line: [
        [121.463582,31.179646],
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.463582,31.179646],
      distance: 511.53846153846155,
    },
    {
      left_line: [
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.463793,31.180116],
      distance: 538.4615384615385,
    },
    {
      left_line: [
        [121.463793,31.180116],
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.463793,31.180116],
      distance: 565.3846153846154,
    },
    {
      left_line: [
        [121.463916,31.180359],
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.463916,31.180359],
      distance: 592.3076923076923,
    },
    {
      left_line: [
        [121.464023,31.180576],
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.464023,31.180576],
      distance: 619.2307692307693,
    },
    {
      left_line: [
        [121.464136,31.180854],
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.464136,31.180854],
      distance: 646.1538461538462,
    },
    {
      left_line: [
        [121.464366,31.181336],
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.464366,31.181336],
      distance: 673.0769230769231,
    },
    {
      left_line: [
        [121.464388,31.181344],
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.464388,31.181344],
      distance: 700,
    },
    {
      left_line: [
        [121.464449,31.181397],
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.464449,31.181397],
      distance: 726.9230769230769
    },
    {
      left_line: [
        [121.464887,31.1822],
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.464887,31.1822],
      distance: 753.8461538461538
    },
    {
      left_line: [
        [121.464992,31.182387],
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.464992,31.182387],
      distance: 780.7692307692308
    },
    {
      left_line: [
        [121.465374,31.183081],
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.465374,31.183081],
      distance: 807.6923076923077
    },
    {
      left_line: [
        [121.465482,31.183206],
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.465482,31.183206],
      distance: 834.6153846153846
    },
    {
      left_line: [
        [121.465656,31.183436],
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.465656,31.183436],
      distance: 861.5384615384615
    },
    {
      left_line: [
        [121.465898,31.183745],
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.465898,31.183745],
      distance: 888.4615384615385
    },
    {
      left_line: [
        [121.465969,31.183849],
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.465969,31.183849],
      distance: 866.25
    },
    {
      left_line: [
        [121.466442,31.184265],
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.466442,31.184265],
      distance: 915.3846153846154
    },
    {
      left_line: [
        [121.466623,31.184436],
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.466623,31.184436],
      distance: 942.3076923076923
    },
    {
      left_line: [
        [121.466659,31.184466],
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.466659,31.184466],
      distance: 969.2307692307693
    },
    {
      left_line: [
        [121.466659,31.18447],
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.466659,31.18447],
      distance: 996.1538461538462
    },
    {
      left_line: [
        [121.466673,31.184482],
        [121.466672,31.184479],
      ],
      point: [121.466673,31.184482],
      distance: 1023.0769230769231
    },
    {
      left_line: [
        [121.466672,31.184479],
      ],
      point: [121.466672,31.184479],
      distance: 1050
    },
  ],
  line2: [
    {
      left_line: [
        [121.466672,31.184479],
        [121.466629,31.18444],
        [121.466446,31.18427],
        [121.465973,31.183853],
        [121.465903,31.183749],
        [121.465661,31.183441],
        [121.465486,31.183211],
        [121.465379,31.183085],
        [121.464997,31.182391],
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.466672,31.184479],
      distance: 0,
    },
    {
      left_line: [
        [121.466629,31.18444],
        [121.466446,31.18427],
        [121.465973,31.183853],
        [121.465903,31.183749],
        [121.465661,31.183441],
        [121.465486,31.183211],
        [121.465379,31.183085],
        [121.464997,31.182391],
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.466629,31.18444],
      distance: 27.63157894736842,
    },
    {
      left_line: [
        [121.466446,31.18427],
        [121.465973,31.183853],
        [121.465903,31.183749],
        [121.465661,31.183441],
        [121.465486,31.183211],
        [121.465379,31.183085],
        [121.464997,31.182391],
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.466446,31.18427],
      distance: 55.26315789473684,
    },
    {
      left_line: [
        [121.465973,31.183853],
        [121.465903,31.183749],
        [121.465661,31.183441],
        [121.465486,31.183211],
        [121.465379,31.183085],
        [121.464997,31.182391],
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.465973,31.183853],
      distance: 82.89473684210526,
    },
    {
      left_line: [
        [121.465903,31.183749],
        [121.465661,31.183441],
        [121.465486,31.183211],
        [121.465379,31.183085],
        [121.464997,31.182391],
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.465903,31.183749],
      distance: 110.52631578947368,
    },
    {
      left_line: [
        [121.465661,31.183441],
        [121.465486,31.183211],
        [121.465379,31.183085],
        [121.464997,31.182391],
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.465661,31.183441],
      distance: 138.1578947368421,
    },
    {
      left_line: [
        [121.465486,31.183211],
        [121.465379,31.183085],
        [121.464997,31.182391],
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.465486,31.183211],
      distance: 165.78947368421052,
    },
    {
      left_line: [
        [121.465379,31.183085],
        [121.464997,31.182391],
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.465379,31.183085],
      distance: 193.42105263157896,
    },
    {
      left_line: [
        [121.464997,31.182391],
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.464997,31.182391],
      distance: 221.05263157894737,
    },
    {
      left_line: [
        [121.464891,31.182204],
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.221485, 31.053651],
      distance: 248.68421052631578,
    },
    {
      left_line: [
        [121.464453,31.181401],
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.464453,31.181401],
      distance: 276.3157894736842,
    },
    {
      left_line: [
        [121.464392,31.181349],
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.464392,31.181349],
      distance: 303.94736842105266,
    },
    {
      left_line: [
        [121.464371,31.18134],
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.464371,31.18134],
      distance: 331.57894736842104,
    },
    {
      left_line: [
        [121.464366,31.181336],
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.464366,31.181336],
      distance: 359.2105263157895,
    },
    {
      left_line: [
        [121.464141,31.180858],
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.464141,31.180858],
      distance: 386.8421052631579,
    },
    {
      left_line: [
        [121.464028,31.180581],
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.464028,31.180581],
      distance: 414.4736842105263,
    },
    {
      left_line: [
        [121.46392,31.180359],
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.46392,31.180359],
      distance: 442.10526315789474,
    },
    {
      left_line: [
        [121.463798,31.180121],
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.463798,31.180121],
      distance: 469.7368421052632,
    },
    {
      left_line: [
        [121.463585,31.179651],
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.463585,31.179651],
      distance: 497.36842105263156,
    },
    {
      left_line: [
        [121.463525,31.179535],
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.463525,31.179535],
      distance: 525,
    },
    {
      left_line: [
        [121.463521,31.17953],
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.463521,31.17953],
      distance: 552.6315789473684,
    },
    {
      left_line: [
        [121.463156,31.179521],
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.463156,31.179521],
      distance: 580.2631578947369,
    },
    {
      left_line: [
        [121.463158,31.179486],
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.463158,31.179486],
      distance: 607.8947368421053,
    },
    {
      left_line: [
        [121.463171,31.179499],
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.463171,31.179499],
      distance: 635.5263157894736,
    },
    {
      left_line: [
        [121.463086,31.179513],
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.463086,31.179513],
      distance: 663.1578947368421,
    },
    {
      left_line: [
        [121.462964,31.17917],
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.462964,31.17917],
      distance: 690.7894736842105,
    },
    {
      left_line: [
        [121.462912,31.179014],
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.462912,31.179014],
      distance: 718.421052631579,
    },
    {
      left_line: [
        [121.462908,31.179009],
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.462908,31.179009],
      distance: 746.0526315789474,
    },
    {
      left_line: [
        [121.462587,31.179127],
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.462587,31.179127],
      distance: 773.6842105263158,
    },
    {
      left_line: [
        [121.462582,31.179127],
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.462582,31.179127],
      distance: 801.3157894736842,
    },
    {
      left_line: [
        [121.462569,31.179114],
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.462569,31.179114],
      distance: 828.9473684210526,
    },
    {
      left_line: [
        [121.461923,31.177524],
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.461923,31.177524],
      distance: 856.578947368421,
    },
    {
      left_line: [
        [121.461918,31.17752],
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.461918,31.17752],
      distance: 884.2105263157895,
    },
    {
      left_line: [
        [121.462071,31.177482],
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.462071,31.177482],
      distance: 911.8421052631579,
    },
    {
      left_line: [
        [121.46214,31.177464],
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],
      ],
      point: [121.46214,31.177464],
      distance: 939.4736842105264,
    },
    {
      left_line: [
        [121.462465,31.177364],
        [121.462483,31.177356],
        [121.462604,31.176882],
        [121.462648,31.176765],],
      point: [121.462465,31.177364],
      distance: 967.1052631578948,
    },
    {
      left_line: [[121.462483,31.177356],[121.462604,31.176882],[121.462648,31.176765],],
      point: [121.462483,31.177356],
      distance: 994.7368421052631,
    },
    { left_line: [[121.462604,31.176882],[121.462648,31.176765]], point: [121.462604,31.176882], distance: 1022.3684210526316 },
    { left_line: [[121.462648,31.176765]], point: [121.462648,31.176765], distance: 1050 },
  ],
  line3: [
    {
      left_line: [
        [121.462648,31.176765],
        [121.462608,31.176752],
        [121.462621,31.176764],
        [121.462678,31.176666],
        [121.462352,31.176149],
        [121.46233,31.176155],
        [121.462343,31.176167],
        [121.462357,31.176158],
        [121.462318,31.176093],
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462648,31.176765],
      distance: 0,
    },
    {
      left_line: [
        [121.462608,31.176752],
        [121.462621,31.176764],
        [121.462678,31.176666],
        [121.462352,31.176149],
        [121.46233,31.176155],
        [121.462343,31.176167],
        [121.462357,31.176158],
        [121.462318,31.176093],
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462608,31.176752],
      distance: 30.967741935483872,
    },
    {
      left_line: [
        [121.462621,31.176764],
        [121.462678,31.176666],
        [121.462352,31.176149],
        [121.46233,31.176155],
        [121.462343,31.176167],
        [121.462357,31.176158],
        [121.462318,31.176093],
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462621,31.176764],
      distance: 61.935483870967744,
    },
    {
      left_line: [
        [121.462678,31.176666],
        [121.462352,31.176149],
        [121.46233,31.176155],
        [121.462343,31.176167],
        [121.462357,31.176158],
        [121.462318,31.176093],
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462678,31.176666],
      distance: 92.90322580645162,
    },
    {
      left_line: [
        [121.462352,31.176149],
        [121.46233,31.176155],
        [121.462343,31.176167],
        [121.462357,31.176158],
        [121.462318,31.176093],
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462352,31.176149],
      distance: 123.87096774193549,
    },
    {
      left_line: [
        [121.46233,31.176155],
        [121.462343,31.176167],
        [121.462357,31.176158],
        [121.462318,31.176093],
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.46233,31.176155],
      distance: 154.83870967741936,
    },
    {
      left_line: [
        [121.462343,31.176167],
        [121.462357,31.176158],
        [121.462318,31.176093],
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462343,31.176167],
      distance: 185.80645161290323,
    },
    {
      left_line: [
        [121.462357,31.176158],
        [121.462318,31.176093],
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462357,31.176158],
      distance: 216.7741935483871,
    },
    {
      left_line: [
        [121.462318,31.176093],
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462318,31.176093],
      distance: 247.74193548387098,
    },
    {
      left_line: [
        [121.462335,31.174209],
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462335,31.174209],
      distance: 278.7096774193549,
    },
    {
      left_line: [
        [121.462404,31.173667],
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462404,31.173667],
      distance: 309.6774193548387,
    },
    {
      left_line: [
        [121.462444,31.173328],
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462444,31.173328],
      distance: 340.64516129032256,
    },
    {
      left_line: [
        [121.462565,31.173146],
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462565,31.173146],
      distance: 371.61290322580646,
    },
    {
      left_line: [
        [121.462595,31.173084],
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462595,31.173084],
      distance: 402.58064516129036,
    },
    {
      left_line: [
        [121.462649,31.172807],
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462649,31.172807],
      distance: 433.5483870967742,
    },
    {
      left_line: [
        [121.462687,31.172703],
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462687,31.172703],
      distance: 464.51612903225805,
    },
    {
      left_line: [
        [121.462786,31.172278],
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462786,31.172278],
      distance: 495.48387096774195,
    },
    {
      left_line: [
        [121.462908,31.171792],
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462908,31.171792],
      distance: 526.4516129032259,
    },
    {
      left_line: [
        [121.462965,31.171596],
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462965,31.171596],
      distance: 557.4193548387098,
    },
    {
      left_line: [
        [121.462999,31.171557],
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.462999,31.171557],
      distance: 588.3870967741935,
    },
    {
      left_line: [
        [121.463038,31.171509],
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.463038,31.171509],
      distance: 619.3548387096774,
    },
    {
      left_line: [
        [121.463069,31.171423],
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.463069,31.171423],
      distance: 650.3225806451613,
    },
    {
      left_line: [
        [121.463077,31.171396],
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.463077,31.171396],
      distance: 681.2903225806451,
    },
    {
      left_line: [
        [121.463252,31.170876],
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.463252,31.170876],
      distance: 712.258064516129,
    },
    {
      left_line: [
        [121.463278,31.170832],
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.463278,31.170832],
      distance: 743.2258064516129,
    },
    {
      left_line: [
        [121.463381,31.170528],
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.463381,31.170528],
      distance: 774.1935483870968,
    },
    {
      left_line: [
        [121.463724,31.169613],
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.463724,31.169613],
      distance: 805.1612903225807,
    },
    {
      left_line: [
        [121.463841,31.169166],
        [121.463841,31.169161],
        [121.463845,31.169101],
        [121.463806,31.168484],
        [121.463859,31.168445],
      ],
      point: [121.463841,31.169166],
      distance: 836.1290322580645,
    },
    {
      left_line: [[121.463841,31.169161], [121.463845,31.169101], [121.463806,31.168484], [121.463859,31.168445]],
      point: [121.463841,31.169161],
      distance: 867.0967741935484,
    },
    {
      left_line: [[121.463845,31.169101], [121.463806,31.168484], [121.463859,31.168445]],
      point: [121.463845,31.169101],
      distance: 898.0645161290323,
    },
    { left_line: [[121.463806,31.168484], [121.463859,31.168445]], point: [121.463806,31.168484], distance: 929.0322580645161 },
    { left_line: [[121.463859,31.168445]], point: [121.463859,31.168445], distance: 960 },
  ],
  line4: [
    {
      left_line: [
        [121.463859,31.168445],
        [121.463873,31.168457],
        [121.463886,31.168469],
        [121.463886,31.168467],
        [121.464032,31.168458],
        [121.464033,31.168458],
        [121.464085,31.168708],
        [121.464098,31.16872],
        [121.464062,31.168706],
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463859,31.168445],
      distance: 0,
    },
    {
      left_line: [
        [121.463873,31.168457],
        [121.463886,31.168469],
        [121.463886,31.168467],
        [121.464032,31.168458],
        [121.464033,31.168458],
        [121.464085,31.168708],
        [121.464098,31.16872],
        [121.464062,31.168706],
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463873,31.168457],
      distance: 26.11111111111111,
    },
    {
      left_line: [
        [121.463886,31.168469],
        [121.463886,31.168467],
        [121.464032,31.168458],
        [121.464033,31.168458],
        [121.464085,31.168708],
        [121.464098,31.16872],
        [121.464062,31.168706],
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463886,31.168469],
      distance: 52.22222222222222,
    },
    {
      left_line: [
        [121.463886,31.168467],
        [121.464032,31.168458],
        [121.464033,31.168458],
        [121.464085,31.168708],
        [121.464098,31.16872],
        [121.464062,31.168706],
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463886,31.168467],
      distance: 78.33333333333333,
    },
    {
      left_line: [
        [121.464032,31.168458],
        [121.464033,31.168458],
        [121.464085,31.168708],
        [121.464098,31.16872],
        [121.464062,31.168706],
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.464032,31.168458],
      distance: 104.44444444444444,
    },
    {
      left_line: [
        [121.464033,31.168458],
        [121.464085,31.168708],
        [121.464098,31.16872],
        [121.464062,31.168706],
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.464033,31.168458],
      distance: 130.55555555555554,
    },
    {
      left_line: [
        [121.464085,31.168708],
        [121.464098,31.16872],
        [121.464062,31.168706],
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.464085,31.168708],
      distance: 156.66666666666666,
    },
    {
      left_line: [
        [121.464098,31.16872],
        [121.464062,31.168706],
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.464098,31.16872],
      distance: 182.77777777777777,
    },
    {
      left_line: [
        [121.464062,31.168706],
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.464062,31.168706],
      distance: 208.88888888888889,
    },
    {
      left_line: [
        [121.463938,31.169001],
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463938,31.169001],
      distance: 235,
    },
    {
      left_line: [
        [121.463845,31.169161],
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463845,31.169161],
      distance: 261.1111111111111,
    },
    {
      left_line: [
        [121.463728,31.169608],
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463728,31.169608],
      distance: 287.22222222222223,
    },
    {
      left_line: [
        [121.463385,31.170524],
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463385,31.170524],
      distance: 313.3333333333333,
    },
    {
      left_line: [
        [121.463282,31.170828],
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463282,31.170828],
      distance: 339.44444444444446,
    },
    {
      left_line: [
        [121.463256,31.170871],
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463256,31.170871],
      distance: 365.55555555555554,
    },
    {
      left_line: [
        [121.463082,31.171391],
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463082,31.171391],
      distance: 391.6666666666667,
    },
    {
      left_line: [
        [121.463073,31.171418],
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463073,31.171418],
      distance: 417.77777777777777,
    },
    {
      left_line: [
        [121.463069,31.171418],
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463069,31.171418],
      distance: 443.88888888888886,
    },
    {
      left_line: [
        [121.463043,31.171505],
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.217258, 31.059704],
      distance: 470,
    },
    {
      left_line: [
        [121.463003,31.171553],
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.463003,31.171553],
      distance: 496.1111111111111,
    },
    {
      left_line: [
        [121.462965,31.171592],
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462965,31.171592],
      distance: 522.2222222222222,
    },
    {
      left_line: [
        [121.462912,31.171787],
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462912,31.171787],
      distance: 548.3333333333334,
    },
    {
      left_line: [
        [121.462791,31.172273],
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462791,31.172273],
      distance: 574.4444444444445,
    },
    {
      left_line: [
        [121.462691,31.172699],
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462691,31.172699],
      distance: 600.5555555555555,
    },
    {
      left_line: [
        [121.462652,31.172803],
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462652,31.172803],
      distance: 626.6666666666666,
    },
    {
      left_line: [
        [121.4626,31.17308],
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.4626,31.17308],
      distance: 652.7777777777777,
    },
    {
      left_line: [
        [121.462569,31.173141],
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462569,31.173141],
      distance: 678.8888888888889,
    },
    {
      left_line: [
        [121.462448,31.173324],
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462448,31.173324],
      distance: 705,
    },
    {
      left_line: [
        [121.462409,31.173662],
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462409,31.173662],
      distance: 731.1111111111111,
    },
    {
      left_line: [
        [121.462339,31.174205],
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462339,31.174205],
      distance: 757.2222222222222,
    },
    {
      left_line: [
        [121.462318,31.176088],
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462318,31.176088],
      distance: 783.3333333333334,
    },
    {
      left_line: [
        [121.462348,31.17614],
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462348,31.17614],
      distance: 809.4444444444445,
    },
    {
      left_line: [
        [121.462336,31.176151],
        [121.462349,31.176163],
        [121.462357,31.176158],
        [121.462678,31.176666],
        [121.462648,31.176765]
      ],
      point: [121.462336,31.176151],
      distance: 835.5555555555555,
    },
    {
      left_line: [[121.462349,31.176163], [121.462357,31.176158], [121.462678,31.176666], [121.462648,31.176765]],
      point: [121.462349,31.176163],
      distance: 861.6666666666666,
    },
    {
      left_line: [[121.462357,31.176158], [121.462678,31.176666], [121.462648,31.176765]],
      point: [121.462357,31.176158],
      distance: 887.7777777777777,
    },
    { left_line: [[121.462678,31.176666], [121.462648,31.176765]], point: [121.462678,31.176666], distance: 913.8888888888889 },
    { left_line: [[121.462648,31.176765]], point: [121.462648,31.176765], distance: 940 },
  ],
}
